import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import "./antd.css";
import App from './routes/App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';

//哨兵初始化
Sentry.init({ dsn: "https://4265dd67b52b43c6948b3c8c27a9e36d@sentry.rup-china.com:9002/6" });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
